import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { saveEvvTimesheetBO } from '../evvtimesheet.model';

@Injectable({
  providedIn: 'root'
})
export class EvvTimesheetEditService {

  constructor(private http: HttpClient, public errorService: ErrorService,
  ) { }


  getActiveAuthsWithinDateRange(params: URLSearchParams): Observable<any> {
    let url = "api/ClientAuthorization/getActiveAuthsWithinDateRange?";
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }


  saveEvvTimesheet(saveEvvTimesheets: saveEvvTimesheetBO): Observable<any> {
    let url = "api/Visit/SaveManualVisit";
    return this.http.post(url, saveEvvTimesheets, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }


  GetClientDropdown(): Observable<any> {
    let url = "api/Client/clientDropDown?";
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }



  GetEmployeePayrateForClient(params: URLSearchParams): Observable<any> {
    let url = "api/EmployeePayrate/GetEmployeePayrateForClient?";
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

}